
export default function ContactInfo() {
  const contactMethods = [
    {
      icon: 'ri-phone-line',
      title: 'Phone',
      details: '(256) 268-7146',
      description: 'Mon-Fri 9AM-6PM CST'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email',
      details: 'Create@oedtinyhomebuilders.com',
      description: 'We respond within 24 hours'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Office',
      details: '1591 Allison Mill Rd, Talladega, AL 35160',
      description: 'By appointment only'
    },
    {
      icon: 'ri-time-line',
      title: 'Business Hours',
      details: 'Monday - Friday: 9AM - 6PM',
      description: 'Weekend: 10AM - 4PM'
    }
  ];

  const socialLinks = [
    { icon: 'ri-instagram-line', name: 'Instagram', url: '#' },
    { icon: 'ri-facebook-line', name: 'Facebook', url: 'https://www.facebook.com/share/1K9aiNB9A9/' },
    { icon: 'ri-twitter-line', name: 'Twitter', url: '#' },
    { icon: 'ri-linkedin-line', name: 'LinkedIn', url: 'https://www.linkedin.com/in/oedtinyhomes' }
  ];

  return (
    <div>
      <h2 className="text-3xl font-bold text-gray-900 mb-6">Get In Touch</h2>
      <p className="text-gray-600 mb-8 leading-relaxed">
        Ready to embark on your glamping adventure or explore investment opportunities? 
        Our team is here to help you every step of the way.
      </p>

      <div className="space-y-6 mb-8">
        {contactMethods.map((method, index) => (
          <div key={index} className="flex items-start">
            <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
              <i className={`${method.icon} text-xl text-emerald-600`}></i>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">{method.title}</h3>
              <p className="text-gray-900 mb-1">{method.details}</p>
              <p className="text-sm text-gray-600">{method.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white p-8 rounded-xl shadow-lg">
        <h3 className="text-xl font-bold text-gray-900 mb-6">Follow Us</h3>
        <div className="flex space-x-4">
          <a 
            href="https://www.facebook.com/share/1K9aiNB9A9/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center text-white hover:bg-emerald-700 transition-colors cursor-pointer"
          >
            <i className="ri-facebook-fill text-lg"></i>
          </a>
          <a 
            href="https://www.instagram.com/oedglampingncamping" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center text-white hover:bg-emerald-700 transition-colors cursor-pointer"
          >
            <i className="ri-instagram-line text-lg"></i>
          </a>
          <a 
            href="https://x.com/oedtinyhomekits" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center text-white hover:bg-emerald-700 transition-colors cursor-pointer"
          >
            <i className="ri-twitter-x-line text-lg"></i>
          </a>
          <a 
            href="https://youtube.com/@tinyhomeinvestmentgroup" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center text-white hover:bg-emerald-700 transition-colors cursor-pointer"
          >
            <i className="ri-youtube-line text-lg"></i>
          </a>
          <a 
            href="https://www.linkedin.com/in/oedtinyhomes" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center text-white hover:bg-emerald-700 transition-colors cursor-pointer"
          >
            <i className="ri-linkedin-fill text-lg"></i>
          </a>
        </div>
      </div>

      <div className="mt-8 p-6 bg-emerald-50 rounded-lg">
        <h3 className="font-semibold text-emerald-900 mb-2">Emergency Contact</h3>
        <p className="text-emerald-800 text-sm">
          For urgent matters related to existing bookings or emergencies at our properties, 
          please call our 24/7 hotline: <strong>(256) 268-7146</strong>
        </p>
      </div>
    </div>
  );
}
